export default "__VITE_ASSET__D3oQ5anz__"